module.exports = "pegasus/assets/question-mark-icon.png";